import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import User from '@ltypes/user';

export const userSlice = createSlice({
    name: 'user',
    initialState: null as User|null,
    reducers: {
        connectUser: (state, action: PayloadAction<User>) => {
            return action.payload;
        },

        disconnectUser: (state) => {
            return null;
        },
        
        updateUser: (state, action) => {
            let oldState = state === null ? {} : state;
            return {
                ...oldState,
                ...action.payload,
            };
        },
    }
});

export const { connectUser, disconnectUser, updateUser } = userSlice.actions;

export default userSlice.reducer;